<template>
    <div class="section">
        <div class="anchor" id="video"></div>
        <img class="title" src="@/assets/images/title_04.png" alt="" />
        <div class="sec-box sec-video" id="sec-video">
            <div class="box-notice">
                <div class="bg">
                    <img class="backward" src="@/assets/images/wave_05.jpg" alt="">
                    <!-- <img class="forward" src="@/assets/images/video.jpg" alt=""> -->

                    <div class="box-video">
                        <div class="video">
                            <p>人工智能伴奏</p>
                            <video controls preload src="@/assets/video/ai.mp4"></video>
                        </div>

                        <div class="video">
                            <p>无人乐队</p>
                            <video controls preload src="@/assets/video/aiband1028.mp4"></video>
                        </div>
                        
                        <div class="video">
                            <p>ASTERISM乐队</p>
                            <video controls preload src="@/assets/video/ASTERISM.mp4"></video>
                        </div>

                        <div class="video">
                            <p>概念乐器设计</p>
                            <video controls src="@/assets/video/except.mp4" poster="@/assets/images/video3.png"></video>
                        </div>

                        
                        <div class="video">
                            <p>萨克斯现场手工雕刻</p>
                            <video controls src="@/assets/video/sax.mp4"></video>
                        </div>

                    </div>
                </div>

                <!-- <div class="notice">
                    <p>本届展会亮点回顾与现场演出<br />请持续关注官方Bilibili公众号@雅马哈乐器音响</p>
                    <a href="https://space.bilibili.com/362791338" class="now" target="_blank">立即前往</a>
                    <a href="https://space.bilibili.com/362791338/channel/detail?cid=55566" class="y2018" target="_blank">前往2018 Music China回顾</a>
                </div> -->
            </div>

            <div class="go-top" v-scroll-to="{ el: '#header-box' }">BACK TO TOP</div>

            <div class="box-gift" @click="showPop(true)">
                <!-- <img src="@/assets/images/wave_06.jpg" alt=""> -->
                <div class="gift"><i class="remixicon-add-line"></i>现场赠品</div>
            </div>
        </div>
        <div v-show="popShow" class="popup" @click="showPop(false)">
            <div class="box" @click="() => {}">
                <img src="@/assets/images/booth-front.jpg" alt="" />
                <div class="btn-plus"><i class="remixicon-close-line" @click="showPop(false)"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SecVideo',
    data() {
        return {
            popShow: false,
            playerOptions: {
                // videojs options
                // muted: true,
                // language: 'en',
                // playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                type: "video/mp4",
                src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                }],
                poster: "/static/images/author.jpg",
            }
        }
    },
    methods: {
        showPop(pop) {
            this.popShow = pop
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/components/variable";

.box-video {
    width: 627px;
    max-width: 100%;
    position: relative;

    .video {
        &+.video {
            margin-top: 50px;
        }

        video {
            margin-top: 10px;
            width: 100%;
        }

        p {
            font-size: 18px;
            color: #fff;
        }
    }

}

.section {
    .title {
        top: 0%;
    }
}


.sec-video {
    display: flex;
    justify-content: center;
    padding-bottom: 120px;

    .title {
        margin: 183px 40px 0 60px;
    }
}

.box-notice {
    position: relative;

    .bg {
        position: relative;
        padding: 30px 0 0 44px;

        .backward {
            position: absolute;
            top: 0;
            left: 0;
        }

        .forward {
            position: relative;
        }
    }
}

.notice {
    position: absolute;
    top: 190px;
    left: 500px;
    color: #fff;

    p {
        font-size: 14px;
        white-space: nowrap;
        line-height: 1.8;
    }

    a.now {
        font-size: 18px;
        border: 1px solid #fff;
        padding: 15px 125px;
        white-space: nowrap;
        margin: 16px 0;
    }

    a.y2018 {
        font-size: 14px;
        white-space: nowrap;
        padding-bottom: 5px;
        border-bottom: 1px solid #fff;
        display: inline-block;
    }
}

.box-gift {
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: pointer;

    &>img {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .gift {
        width: 127px;
        height: 66px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background-color: $purple;
        position: relative;
        z-index: 1;
    }
}

@media all and (max-width: 768px) {

.box-video .video p {
    font-size: 4vw;
}

.sec-video {
    flex-wrap: wrap;
}

.box-video {

    video {

        &+video {
            margin-top: 30px;
        }
    }
}

.box-notice {
    max-width: 90%;
    margin: 0 auto;

    .forward {
        max-width: 100%;
    }

    .backward {
        max-width: 60%;
    }
}

.notice {
    position: relative;
    top: auto;
    left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5%;
    
    p {
        text-align: center;
    }

    a {
        text-align: center;

        &.now {
            padding: 4% 0;
            width: 80%;
            
        }
    }
}

}
</style>